<div class="modal-header">
  <h4 class="modal-title">{{title | translate }}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label">{{isConfigurationGroupType() ? ('editProjectGroup.label.project_name' | translate) : ('editProjectGroup.label.name' | translate)}}: </label>
        <div class="col-md-8">
          <input type="text"
                 spellcheck="false"
                 class="form-control"
                 id="groupNameTextInput"
                 [maxLength]="MAX_GROUP_NAME_LENGTH"
                 #groupNameTextInput
                 (input)="onGroupNameInput($event)"
                 (keydown.enter)="save()">
          <div class="invalid-feedback" [ngClass]="groupNameError ? 'd-block' : ''">{{groupNameError | translate}}</div>
        </div>
      </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" data-testid="close-button" class="btn btn-secondary btn-cancel" (click)="close()">
    {{'global.label.cancel' | translate}}
  </button>
  <button type="button" data-testid="save-button" class="btn btn-primary btn-forward" [disabled]="!groupNameTextInput.value.trim() || groupNameError" (click)="save()">
    {{'global.label.save' | translate}}
  </button>
</div>
